<style>
@import './style/common.less';

#app {
  height: 100%;
}

.ant-table-thead > tr > th {
  background-color: #008e4d !important;
  color: white !important;
}

.ant-table,
.ant-table-container,
.ant-table-content table {
  border: none !important;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  border: none !important;
}

/* Remove extra divider lines */
.ant-table-thead > tr > th::before {
  display: none !important;
}

/* Popup menu width when sidebar is collapsed */
.ant-menu-submenu-popup {
  min-width: 220px !important;
}

.ant-menu-submenu-popup .ant-menu-sub {
  min-width: 220px !important;
}
</style>
<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
      <div v-if="showWatermark" v-watermark="{ watermarkText: watermarkText }" />
    </div>
  </a-config-provider>
</template>

<script>
import store from '@/store/'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import viVN from 'ant-design-vue/lib/locale-provider/vi_VN'
import { AppDeviceEnquire } from '@/utils/mixin'
import { mapGetters } from 'vuex'
import moment from 'moment'
import lang from './i18n/lang'
import 'moment/locale/es'
import 'moment/locale/vi'

const EN = 'en-us'
moment.locale(EN)

export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      locale: enUS,
      watermarkText: '', // Watermark text
      showWatermark: true, // Whether to show watermark
    }
  },
  watch: {
    $route(to, from) {
      // Re-check watermark display when route changes to /user/login
      if (to.path === '/user/login' || from.path === '/user/login') {
        this.showWatermark = false
        this.initWatermark()
      } else {
        this.showWatermark = true
      }
    },
    languageStorage: {
      handler(lang) {
        if (lang == 'es') {
          // The project uses 'es' as the language code for Vietnamese, so set moment locale to Vietnamese
          moment.locale('vi')
          this.locale = viVN
        } else {
          moment.locale(EN)
          this.locale = enUS
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.showWatermark=process.env.VUE_APP_SHOW_WATER_MARKER
    // console.log(process.env.VUE_APP_SHOW_WATER_MARKER)
  },
  created() {
    this.initWatermark()
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
  },
  methods: {
    initWatermark() {
      const watermakerInfo = localStorage.getItem('userName') // Get watermark info from local storage
      if (watermakerInfo) {
        this.watermarkText = watermakerInfo
      }
    },
  },
}
</script>
